//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue';
import customMarker from 'images/map_marker.png';
import ProjectMapCard from './ProjectMapCard.vue';
import { createPopper } from '@popperjs/core';
import { gmapApi } from 'vue2-google-maps';

const CITIES = {
  MELBOURNE: 'MELBOURNE',
  AUCKLAND: 'AUCKLAND'
};

const CITY_LOCATIONS = {
  MELBOURNE: { lat: -37.840935, lng: 144.946457 },
  AUCKLAND: { lat: -36.86667, lng: 174.76667 }
};

export default {
  props: {
    projects: Array,
    title: String,
    backgroundImage: String
  },
  data: function () {
    return {
      google: gmapApi,
      selectedCity: CITIES.MELBOURNE,
      selectedProject: undefined,
      cities: CITIES,
      markerIcon: {
        url: customMarker,
        size: { width: 24, height: 36, f: 'px', b: 'px' },
        scaledSize: { width: 24, height: 36, f: 'px', b: 'px' }
      },
      mapCenter: { lat: -37.840935, lng: 144.946457 },
      mapOptions: {
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false,
        zoomControlOptions: {
          position: 6
        },
        styles: [
          { elementType: 'geometry', stylers: [{ color: '#000000' }] },
          {
            elementType: 'labels.text.stroke',
            stylers: [{ color: '#1e1e1e' }]
          },
          { elementType: 'labels.text.fill', stylers: [{ color: '#afafaf' }] },
          {
            featureType: 'poi',
            elementType: 'all',
            stylers: [
              {
                visibility: 'off'
              }
            ]
          },
          {
            featureType: 'transit',
            elementType: 'all',
            stylers: [
              {
                visibility: 'off'
              }
            ]
          },
          {
            featureType: 'all',
            elementType: 'labels.icon',
            stylers: [
              {
                visibility: 'off'
              }
            ]
          },
          {
            featureType: 'road',
            elementType: 'all',
            stylers: [
              {
                color: '#1e1e1e'
              },
              {
                weight: '0.70'
              }
            ]
          },
          {
            featureType: 'road.arterial',
            elementType: 'all',
            stylers: [
              {
                visibility: 'off'
              }
            ]
          },
          {
            featureType: 'water',
            elementType: 'geometry',
            stylers: [
              {
                color: '#262626'
              }
            ]
          }
        ]
      }
    };
  },
  computed: {
    projectsToDisplay: function () {
      return this.projects.map((project) => ({
        ...project,
        geolocation: {
          lat: Number(project.geolocation.lat),
          lng: Number(project.geolocation.lng)
        }
      }));
    },
    style: function () {
      return { background: `url(${this.backgroundImage})` };
    }
  },
  methods: {
    getMouseEvent: function (event) {
      const mouseEventKey = Object.keys(event).find(
        (eventProp) =>
          event[eventProp] && event[eventProp] instanceof MouseEvent
      );

      const mouseEvent = event[mouseEventKey];

      return mouseEvent;
    },
    onMarkerMouseOver: function (project, event) {
      const mouseEvent = this.getMouseEvent(event);

      if (mouseEvent && mouseEvent.target && this.$refs.popperContainer) {
        this.selectedProject = project;
        createPopper(mouseEvent.target, this.$refs.popperContainer);
      }
    },
    onMarkerMouseLeave: function (event) {
      const mouseEvent = this.getMouseEvent(event);

      if (!mouseEvent || !mouseEvent.relatedTarget) {
        this.selectedProject = undefined;
      }

      if (
        mouseEvent &&
        mouseEvent.relatedTarget === this.$refs.popperContainer
      ) {
        return;
      }

      this.selectedProject = undefined;
    },
    closePopper: function () {
      this.selectedProject = undefined;
    },
    selectCity: function (city) {
      this.selectedCity = city;
      this.mapCenter = CITY_LOCATIONS[city];
    }
  },
  components: {
    ProjectMapCard: ProjectMapCard
  }
};



// WEBPACK FOOTER //
// ./scripts/vue/projects-map/ProjectsMap.vue